export const QUERY_KEYS = {
  GET_ACCOUNT: 'GET_ACCOUNT',
  GET_ACCOUNT_PRODUCTS: 'GET_ACCOUNT_PRODUCTS',
  GET_PRODUCT_CONSUMER_SCANS_INFO: 'GET_PRODUCT_CONSUMER_SCANS_INFO',
  GET_ACCOUNT_IMPACTS: 'GET_ACCOUNT_IMPACTS',
  GET_PRODUCT: 'GET_PRODUCT',
  GET_PUBLIC_PRODUCTS: 'GET_PUBLIC_PRODUCTS',
  GET_POPULAR_PRODUCTS: 'GET_POPULAR_PRODUCTS',
  GET_PRODUCT_IMPACTS: 'GET_PRODUCT_IMPACTS',
  GET_STEP_TRANSACTIONS: 'GET_STEP_TRANSACTIONS',
  GET_PRODUCT_JOURNEY: 'GET_PRODUCT_JOURNEY',
  GET_PRODUCT_SIMPLE_ID: 'GET_PRODUCT_SIMPLE_ID',
  GET_ACCOUNT_SIMPLE_ID: 'GET_ACCOUNT_SIMPLE_ID',
  GET_PUBLIC_ACCOUNTS: 'GET_PUBLIC_ACCOUNTS',
  GET_PRODUCT_LOCALES: 'GET_PRODUCT_LOCALES',
  GET_PRODUCT_REDIRECT_URLS: 'GET_PRODUCT_REDIRECT_URLS',
  GET_ACCOUNT_REDIRECT_URL: 'GET_ACCOUNT_REDIRECT_URL',
  GET_HOME_PAGE_SETTINGS: 'GET_HOME_PAGE_SETTINGS',

  GET_AUTH_USER: 'GET_AUTH_USER',
  GET_ME: 'GET_ME',
  GET_ACCOUNT_STYLES: 'GET_ACCOUNT_STYLES',
}
